import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import { jsx as _jsx } from "react/jsx-runtime";
function Accordion(props) {
  const {
    children,
    defaultOpen,
    title
  } = props;
  return /*#__PURE__*/_jsx(UIAccordionItem, {
    title: title,
    defaultOpen: defaultOpen,
    size: "small",
    children: children
  });
}
export default Accordion;